import { combineReducers } from 'redux';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import set from 'lodash/set';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import cloneDeep from 'lodash/cloneDeep';

import { reducer as impressions } from '@nerdwallet/nw-client-lib/tracking';
import { Reducer as experiments } from '@nerdwallet/nw-client-lib/ab';
import compareCards from '@nerdwallet/compare-credit-cards-bar/reducers';
import identityReducer from '@nerdwallet/js-auth-tools/reducers';

import * as MainActions from './actions/main-actions';

import errors from './errors/reducer';
import loading from './loading/reducer';
import mediaQuery from './media-query/reducer';

// Component Reducers
import { forms } from '../components/grid-form/reducer';
import builder from '../containers/builder/reducer';

const combinedReducers = combineReducers({
  compareCards,
  builder,
  errors,
  experiments,
  forms,
  identity: identityReducer,
  impressions,
  loading,
  mediaQuery,
  trackingCookies: (state = {}) => state,
});

export default function rootReducer(state = {}, action) {
  switch (action.type) {
    case MainActions.RAW_UPDATE:
      return set(
        cloneDeep(combinedReducers(state, action)),
        action.path,
        action.value
      );
    default:
      return combinedReducers(state, action);
  }
}
